import React from 'react';

import NextImage from 'next/image';

import { AppRatingSection } from '../../../../components/AppRatingSection/AppRatingSection';
import { ExternalLink } from '../../../../components/Clickables/ExternalLink/ExternalLink';
import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { ADVERTISE_CONTACTS } from '../../../../constants/constants';
import headerWaveMobile from '../../assets/header/headerWaveMobile.svg';
import headerWaveTablet from '../../assets/header/headerWaveTablet.svg';
import header from '../../assets/header.png';
import { DetailsBarSection } from '../DetailsBarSection/DetailsBarSections';

export const AdvertiseHeaderSection = () => {
  return (
    <section
      className="col-start-1 row-start-1 mt-10 grid grid-cols-1 md:mt-40"
      data-testid="AdvertiseHeaderSection"
    >
      <div className="col-start-1 row-start-1 flex flex-col justify-end md:hidden">
        <NextImage
          className="w-full sm:hidden"
          src={headerWaveMobile}
          alt="depth background centre mobile"
        />
        <NextImage
          className="hidden w-full sm:block"
          src={headerWaveTablet}
          alt="depth background centre desktop"
        />
      </div>

      <Container className="col-start-1 row-start-1 grid grid-cols-1 flex-col md:grid-cols-12 md:flex-row md:justify-around">
        <div className="col-span-full mb-5 md:col-span-5 md:col-start-2 md:mb-0">
          <Heading variant="xl" as="h1" className="mb-2">
            Meet Fishbrain
          </Heading>

          <Text variant="md">
            <span className="leading-normal">
              Dive into a world where millions of passionate anglers and outdoor enthusiasts
              connect, engage, and share their experiences.
              <br />
              <br />
              Every interaction on Fishbrain is a testament to its user&apos;s dedication and
              passion.
              <br />
              <br />
              Here, they&apos;re not merely scrolling, but deeply engaging - sharing catches,
              discussing the best baits and spots, and exchanging tips that only true enthusiasts
              would appreciate.
            </span>
          </Text>

          <Text variant="md">Contact sales at </Text>
          {ADVERTISE_CONTACTS.map(contact => {
            return (
              <Text key={contact.contactName} variant="md" className="flex flex-col">
                <span className="font-semibold" key={contact.contactName}>
                  {contact.contactName}
                </span>
                <span key={contact.contactPosition}>{contact.contactPosition}</span>
                <ExternalLink href={`mailto:${contact.contactEmail}`}>
                  {contact.contactEmail}
                </ExternalLink>
                <ExternalLink href={`tel:${contact.contactPhone}`}>
                  {contact.contactPhone}
                </ExternalLink>
              </Text>
            );
          })}

          <div className="mt-6 hidden flex-col md:mt-6 md:flex md:flex-row md:items-center md:gap-x-6">
            <div className="flex flex-col md:flex-row-reverse md:gap-x-12">
              <AppRatingSection bottomOfPage />
            </div>
          </div>
        </div>

        <div className="relative col-span-full justify-end md:col-span-5 md:-mt-24">
          <NextImage
            alt="App preview image"
            src={header}
            className="size-full object-cover sm:object-contain"
            priority
          />
        </div>
        <div className="col-span-full mt-6 flex flex-col md:mt-6 md:hidden">
          <div className="flex flex-col">
            <AppRatingSection className="mb-10" bottomOfPage />
          </div>
        </div>
      </Container>
      <DetailsBarSection />
    </section>
  );
};
